/**
 * @module
 * @category State
 */

import { createSnackbarQueueState, type SnackbarKey, type SnackbarQueue, type SnackbarQueueItem, type SnackbarQueueOptions, type SnackbarVariant } from 'BomdisoftComponents/notifications/snackbars/queue';
import { create } from '@bomdisoft/store/react';
import type { ReactNode } from 'react';

export type { SnackbarAnchorOrigin, SnackbarIndicator, SnackbarKey, SnackbarSurface, SnackbarVariant } from 'BomdisoftComponents/notifications/snackbars/queue';

export type VariantType = SnackbarVariant;

export type SnackbarMessage = ReactNode;

export type SnackbarOptions = SnackbarQueueOptions<SnackbarMessage>;

export type SnackbarItem = SnackbarQueueItem<SnackbarMessage>;

export const useSnackbarStore = create<SnackbarQueue<SnackbarMessage>>()(createSnackbarQueueState<SnackbarMessage>());

export const enqueueSnackbar = (message: SnackbarMessage, options?: SnackbarOptions): SnackbarKey => useSnackbarStore.getState().enqueue(message, options);

export const closeSnackbar = (id?: SnackbarKey): void => useSnackbarStore.getState().close(id);

export const useSnackbar = () => {
  const enqueue = useSnackbarStore(store => store.enqueue);
  const close = useSnackbarStore(store => store.close);
  return { closeSnackbar: close, enqueueSnackbar: enqueue };
};
